import { useMutation } from "@apollo/client";
import { CREATE_SHAREABLE_LINK } from "../gql";
import type {
  CreateShareableLinkInput,
  CreateShareableLinkPayload,
  ShareableLink,
} from "@casey/db-types";

interface CreateShareableLinkVariables {
  input: CreateShareableLinkInput;
}

interface CreateShareableLinkResponse {
  createShareableLink: CreateShareableLinkPayload;
}

interface ShareableLinkInputData {
  assetId: string;
  organizationId: string;
  accessType: "open" | "team" | "individual";
  targetUserId?: string;
  expiresAt?: string;
  createdByUserId: string;
}

export function useCreateShareableLink() {
  const [createShareableLink, { data, loading, error }] = useMutation<
    CreateShareableLinkResponse,
    CreateShareableLinkVariables
  >(CREATE_SHAREABLE_LINK);

  const create = async (input: ShareableLinkInputData) => {
    try {
      const result = await createShareableLink({
        variables: {
          input: {
            shareableLink: input,
            clientMutationId: `create-shareable-link-${Date.now()}`,
          },
        },
      });

      return result.data?.createShareableLink?.shareableLink;
    } catch (err) {
      console.error("Error creating shareable link:", err);
      throw err;
    }
  };

  return {
    create,
    shareableLink: data?.createShareableLink?.shareableLink,
    loading,
    error,
  };
}
